<template>
    <div>
        <div class="card bg-light mb-0">
            <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                <h6 class="mb-0"><font-awesome-icon icon="plus-circle" /> Leave Credit</h6>
            </div>
            <div class="card-body bg-white position-relative">
                <b-row align-v="center" class="loader" v-if="is_saving">
                    <b-col>
                        <b-spinner></b-spinner>
                        <br><br>
                        <strong>Loading</strong>
                    </b-col>
                </b-row>
                <b-form @submit.prevent="save">

                    <b-form-group
                            label="Leave Description:"
                            description="This field is required"
                    >
                        <select class="form-control form-control-sm"  required @change="selectLeave($event)">
                            <option value="">Please Select</option>
                            <option v-for="row in leave_benefits" :value="row.id">
                                {{row.description}}
                            </option>
                        </select>
                    </b-form-group>
                    <b-form-group label="Yearly Credits:" description="This field is required">
                        <b-form-input v-model="form.yearly_credits" type="number" step="any" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Effective Date:" description="This field is required">
                        <b-form-input v-model="form.effective_date" type="date" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Remarks:" description="This field is required">
                        <b-form-input v-model="form.remarks" type="text" required size="sm"></b-form-input>
                    </b-form-group>
                    <div class="text-right mt-3">
                        <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Save</b-button>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>
    import SwalMixin from '@/views/mixins/Swal.js'
    export default {
        mixins:[SwalMixin],
        data() {
            return {
                is_saving:false,
                form:{
                    id:-1,
                    leave_benefit_id:'',
                    yearly_credits:'',
                    effective_date:'',
                    remarks:''
                },
                leave_benefits:[]
            }
        },

        created(){
            this.getFields();
        },
        methods: {

            getFields(){
                this.is_saving=true;
                this.axios.get('maintenance/leave-benefits/all').then(response => {
                    this.leave_benefits=response.data;
                    this.is_saving=false;
                }).catch(error => console.log(error));
            },
            selectLeave(event){
                let selected_row = this.leave_benefits.find(element => element.id==event.target.value);
                this.form.leave_benefit_id = event.target.value;
                this.form.yearly_credits=selected_row.yearly_credits;
            },
            save() {
                this.swalConfirmSubmit((data) => {
                    if (data.value) {
                        this.is_saving = true;
                        this.form.manpower_id = this.$route.params.id;
                        this.axios.post('maintenance/manpowers/leave-benefits/save', this.form).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving = false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving = false;
                        });
                    }
                });
            },
        }
    }
</script>
